var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBrandButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2064_98117)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    rx: 8,
    fill: "#DD0071"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.66634 3.99998C8.66634 3.63179 8.36786 3.33331 7.99967 3.33331C7.63148 3.33331 7.33301 3.63179 7.33301 3.99998V7.33331H3.99967C3.63148 7.33331 3.33301 7.63179 3.33301 7.99998C3.33301 8.36817 3.63148 8.66665 3.99967 8.66665H7.33301V12C7.33301 12.3682 7.63148 12.6666 7.99967 12.6666C8.36786 12.6666 8.66634 12.3682 8.66634 12V8.66665H11.9997C12.3679 8.66665 12.6663 8.36817 12.6663 7.99998C12.6663 7.63179 12.3679 7.33331 11.9997 7.33331H8.66634V3.99998Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2064_98117"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    rx: 8,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrandButton);
export default __webpack_public_path__ + "static/media/brand_button.8b549fd8ef8d4bbe4d75c00938904351.svg";
export { ForwardRef as ReactComponent };